// extracted by mini-css-extract-plugin
export default {"wrapper":"My-z","addressLine":"Ny-z","fullName":"Oy-z"};